import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import LayersForm from "./LayersForm"
import MeatForm from "./meat-form/MeatForm"

/* Protopia Ecosystem component */
export interface IFloatPanelsProps {
   
}
const FloatPanels = (props: IFloatPanelsProps): JSX.Element => {
    const { isEdit, isLayers, isLayersTread, isMeat, isMeatTread }     = useLandingConsoleStore( (state: ILandingConsoleStore) => state )
    return <div className='pe-float-panels'>
        {
            isEdit && isLayers && !isLayersTread &&
            <LayersForm />
        }
        {
            isEdit && isMeat && !isMeatTread &&
            <MeatForm />
        }
    </div>
}
export default FloatPanels